module.exports = __webpack_public_path__ + "static/media/branch-london.3468c69e.jpg";